export const API_TYPE = {
  EDGE_API: "edge-api",
  API: "api",
};
